:host {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #333333;
}

@media screen and (max-width: 979px) {
  :host {
    padding-top: 14px;
    padding-bottom: 8px;
  }
}